<i18n src="@/lang/protocols.yaml"></i18n>

<template lang="pug">
.d-inline-block
    //- Button Add
    button.btn.btn-sm.btn-link(v-if="mode === 'add'", @click="showModal = true")
        font-awesome-icon(icon="fire")
        span.d-none.d-sm-inline.ml-1 Feuerstätte hinzufügen
    //- Button Edit
    a.link.small(v-else, @click="showModal = true") bearbeiten

    //- Modal
    .modal-backdrop.fade.show(v-if="showModal")
    .modal(:class="{ 'd-block': showModal }")
        .modal-dialog.modal-dialog-scrollable.modal-md: .modal-content
            header.modal-header
                h5.modal-title(v-if="mode === 'add'") Feuerstätte hinzufügen
                h5.modal-title(v-else) Feuerstätte bearbeiten
                button.close(type="button", @click="showModal = false") &times;

            .modal-body
                //- Fuel Formgroup
                .form-group.mb-4
                    label.label-title Wählen Sie die Art des Brennstoffes:
                    div
                        .custom-control.custom-control-inline.custom-radio
                            input.custom-control-input(
                                :id="`${_uid}_fuelGas`",
                                type="radio",
                                v-model="fireplace.fuel",
                                value="gas"
                            )
                            label.custom-control-label(:for="`${_uid}_fuelGas`") Gas
                        .custom-control.custom-control-inline.custom-radio
                            input.custom-control-input(
                                :id="`${_uid}_fuelSolid`",
                                type="radio",
                                v-model="fireplace.fuel",
                                value="solid"
                            )
                            label.custom-control-label(:for="`${_uid}_fuelSolid`") Fest (Holz, Kohle, etc.)
                        .custom-control.custom-control-inline.custom-radio
                            input.custom-control-input(
                                :id="`${_uid}_fuelLiquid`",
                                type="radio",
                                v-model="fireplace.fuel",
                                value="liquid"
                            )
                            label.custom-control-label(:for="`${_uid}_fuelLiquid`") Flüssig (Ethanol, Öl, etc.)

                //- Category Formgroup
                .form-group.mb-4(v-if="fireplace.fuel")
                    label.label-title Wählen Sie die Bezeichnung der Feuerstätte:
                    select.custom-select(v-model="fireplace.category")
                        option(:value="undefined", disabled) Bitte auswählen
                        option(:value="c.value", v-for="c in categories") {{ c.text }}

                //- Class Formgroup
                .form-group.mb-4(v-if="fireplace.fuel == 'gas'")
                    label.label-title Genauer Typ der Gasanlage:
                    help-text-modal(:body="$t('modals.fireplace.class.helptext')")
                    typeahead(v-model="fireplace.class", :data="fireplaceClasses", :min-matching-chars="1", ref="classTypeahead")
                    small.form-text.text-muted bspw. B11BS oder B42

                //- Output Formgroup
                .form-group.mb-5
                    label.label-title {{ fireplace.fuel == 'solid' ? 'Fiktive' : '' }} Nennleistung (kW):
                    help-text-modal(:body="$t('modals.fireplace.output.helptext')")
                    numeric-input(v-model.number="fireplace.output", allowMath=true)

                //- Description Formgroup
                character-count-textarea(
                    v-model="fireplace.description",
                    description="bspw. Hersteller und Typenbezeichnung"
                )

            footer.modal-footer
                button.btn.btn-secondary(type="button", @click="showModal = false") Abbrechen
                button.btn.btn-primary(v-if="mode === 'add'", type="button", @click="addAndClose") Feuerstätte hinzufügen
                button.btn.btn-primary(v-else, type="button", @click="addAndClose") Feuerstätte speichern
</template>

<script>
import { Fireplace } from 'trgi'
import Typeahead from 'vue-bootstrap-typeahead'
import { fireplaceClasses, fireplaceTypes } from '@/constants'
import CharacterCountTextarea from '@/components/CharacterCountTextarea'
import HelpTextModal from '@/components/HelpTextModal'
import NumericInput from '@/components/NumericInput'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faFire, faTimes } from '@fortawesome/free-solid-svg-icons'

library.add(faFire, faTimes)

export default {
    components: {
        CharacterCountTextarea,
        HelpTextModal,
        NumericInput,
        Typeahead
    },
    props: {
        value: {
            type: Fireplace,
            required: false,
            default: function () {
                return new Fireplace()
            }
        }
    },
    data () {
        const fireplace = new Fireplace(this.value)
        return {
            fireplace,
            mode: this.value.output ? 'edit' : 'add',
            showModal: false,
            fireplaceClasses
        }
    },
    computed: {
        categories () {
            if (!this.fireplace.fuel) {
                return fireplaceTypes
            }

            return fireplaceTypes.filter(t => t.fuel.includes(this.fireplace.fuel))
        }
    },
    mounted () {
        this.$refs.classTypeahead.inputValue = this.fireplace.class
    },
    watch: {
        // When Fireplace gets modified (e.g. deleted), refresh Local Fireplace Variable
        value (value) {
            this.fireplace = new Fireplace(this.value)
            this.mode = this.fireplace.output ? 'edit' : 'add'
        }
    },
    methods: {
        addAndClose () {
            this.$emit('input', this.fireplace)
            this.showModal = false

            // Reset Fireplace after Changes are populated
            this.$nextTick(function () {
                this.fireplace = new Fireplace(this.value)
                // maybe mode changed too
                this.mode = this.fireplace.output ? 'edit' : 'add'
            })
        }
    }
}
</script>

<style scoped>
.d-inline-block a.link {
    cursor: pointer;
}
</style>
